export const APPLE_TEAM_ID = 10982;

export const RICOH_TEAM_ID = 44459;

export const SIEMENS_TEAM_ID = 12598;

export const ELEVANCE_HEALTH_TEAM_ID = 419;

export const BIZLY_TEAM_ID = 3;

export const PINTEREST_TEAM_ID = 15219;

export const ESTEE_LAUDER_TEAM_ID = 5;

export const BCD_TEAM_ID = 45864;

export const OKTA_TEAM_ID = 15903;

export const DOLBY_TEAM_ID = 13429;

export const ALIGNTECH_TEAM_ID = import.meta.env.VITE_APP_ENV === 'prod' ? 46210 : 46177;
